import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
export function CtaSection() {
  return <section className="w-full py-20 px-4" data-id="element-12">
      <div className="max-w-3xl mx-auto text-center" data-id="element-13">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-cream-card p-8 md:p-12 rounded-2xl shadow-xl border-2 border-forest/20" data-id="element-14">
          <h2 className="font-handwriting text-4xl md:text-5xl text-forest font-bold mb-4" data-id="element-15">
            Bring den Darm deines Hundes wieder in Schwung
          </h2>

          <p className="font-serif text-lg text-gray-700 mb-8 max-w-xl mx-auto" data-id="element-16">
            Natürliche Ballaststoffe für eine gesunde Darmpassage – risikofrei
            testen mit Geld-zurück-Garantie.
          </p>

          <a href="https://hunderunde.shop/products/futtertopping-magen-darm" target="_blank" rel="noopener noreferrer" className="inline-block w-full md:w-auto bg-forest hover:bg-forest-light text-white font-serif font-bold text-lg py-4 px-8 rounded-full transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-1 mb-6" data-id="element-17">
            Jetzt für meinen Hund entdecken →
          </a>

          <div className="flex flex-wrap justify-center gap-4 md:gap-6 text-sm font-serif text-gray-600" data-id="element-18">
            <div className="flex items-center gap-1" data-id="element-19">
              <Check className="w-4 h-4 text-forest" data-id="element-20" />
              <span data-id="element-21">Schneller Versand</span>
            </div>
            <div className="flex items-center gap-1" data-id="element-22">
              <Check className="w-4 h-4 text-forest" data-id="element-23" />
              <span data-id="element-24">Zufriedenheitsgarantie</span>
            </div>
            <div className="flex items-center gap-1" data-id="element-25">
              <Check className="w-4 h-4 text-forest" data-id="element-26" />
              <span data-id="element-27">100% Natürliche Inhaltsstoffe</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}